const Questions = [
  {
    question: "Pick your favourite way to get to work.",
    options: [
      {
        option: "City Bus",
        summary: "No car? No problem.",
        image: "Q1 - City Bus.png",
        desc: "Kingston Transit is the fastest growing transit system in the country. Leave when you want to - service runs every 5 minutes during peak hours."
      },
      {
        option: "Driving",
        summary: "Roll down the windows and take in the view.",
        image: "Q1 - Driving.png",
        desc: "Gridlock? Rush-hour? Never heard of it. If you love to hit the road, take advantage of the easy driving in Kingston."
      },
      {
        option: "Biking",
        summary: "Expedite your commute.",
        image: "Q1 - Biking.png",
        desc:
          "Kingston continues to build its network of bike lanes to support all of your two-wheeled needs."
      },
      {
        option: "Walking",
        summary: "Take control of your commute.",
        image: "Q1 - Walking.png",
        desc: "Many Kingston neighbourhoods designed to encompass living, working, and play, meaning that your favourite grocery store, restaurant, and place of work are within easy walking distance."

      }
    ]
  },
  {
    question: "Pick your favourite amenities.",
    options: [
      {
        option: "Restaurants & Bars",
        summary: "Enjoy a lively entertainment and nightlife scene.",
        image: "Q2 - Restaurants.png",
        desc:
          "You prefer a neighbourhood where play means happy hour."
      },
      {
        option: "Arenas & Fields",
        summary: "Lead a healthy active lifestyle.",
        image: "Q2 - Arenas and Fields.png",
        desc:
          "You want to be close to hockey rinks, soccer fields, and the best parks to play in."
      },
      {
        option: "Dog Parks",
        summary: "Freedom for your furry friends.",
        image: "Q2 - Dog Parks.png",
        desc:
          "With several off-leash dog parks, you and your canine best friend will have plenty of space to play in Kingston."
      },
      {
        option: "Waterfront",
        summary: "Quench your thirst.",
        image: "Q2 - Waterfront.png",
        desc:
          "With access to everything from world-class sailing to stand up paddle boarding – Kingston is a paradise for watersport enthusiasts."
      }
    ]
  },
  {
    question:
      "Pick the services that are the most important to you.",
    options: [
      {
        image: "Q3 - Hospitals.png",
        option: "Hospital",
        summary: "Do you or a loved one need regular access to a nearby hospital?",
      },
      {
        image: "Q3 - Childcare.png",
        option: "Childcare",
        summary: "Do you need regular access to childcare?",
      },
      {
        image: "Q3 - Long-term care.png",
        option: "Long-term care",
        summary: "Do you need regular access to a long-term care facility for a family member?",
      }
    ]
  },
  {
    question: "Pick your dream home.",
    options: [
      {
        option: "Historic",
        image: "Q4 - Historic.png",
        summary: "They just don’t make ’em like they used to.",
        desc: "Kingston has an abundance of well-persevered homes with original construction dating back to pre-World War I. There’s an undeniable romance to well-preserved historic architecture."
      },
      {
        option: "Modern",
        image: "Q4 - Modern.png",
        summary: "Live comfortably and stress-free.",
        desc: "Whether it’s a new kitchen with ample counter space or a large master bedroom with a walk-in closet, modern homes come with their own perks and comforts."
      }
    ]
  },
  {
    question: "Pick your dream backyard.",
    options: [
      {
        option: "Endless",
        summary: "Enjoy the natural beauty of Kingston at your pace.",
        image:
          "Q5 - Endless.png",
        desc:
          "Why not save downtown for the work week? Become the proud owner of one of Kingston’s beautiful acreages. Our countryside neighbourhoods are still only a 15-minute drive from downtown."
      },
      {
        option: "A Private Oasis",
        summary: "A home with a backyard.",
        image: "Q5 - Private Oasis.png",
        desc:
          "Unlike other metro areas where backyard equals suburbs, in Kingston are backyards not only available in the city, many are affordable."
      },
      {
        option: "A City Park",
        summary: "Share the outdoors with your neighbours.",
        image: "Q5 - City Park.png",
        desc:
          "Who needs a backyard? The city has 22 parks, 9 splash pads, and 17 outdoor rinks."
      }
    ]
  }
];

export default Questions;



// WEBPACK FOOTER //
// ./src/components/pages/Survey/Questions.js